export const settlementBasisCalc = (settlementBasis) => {

    let result = (settlementBasis - 1) * 100

    return (result >= 0) ? ` +${Math.round(result)}` : ` ${Math.round(result)}`

}

export const getSettlementBasis = (name, val) => {
    if (name) {
        return name
    } else {
        return val < 1 ? 'Selling price ' : 'Cost price '
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/SettlementBasis.tsx